import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input, OnChanges,
    Output,
    ViewChild,
    SimpleChanges,
    OnDestroy
} from '@angular/core';
import {alarmNameTypeMapping} from '../../../../../shared/classes/alarms/alarm-name-type-mapping';
import {AlarmParameterDefaultForm} from '../../../../../shared/classes/alarms/alarm-parameters/alarm-parameter-default-form';
import {DefaultViewContainerRefDirective} from '../../../../../shared/directives/default-view-container-ref.directive';
import {ToastrService} from 'ngx-toastr';
import {Observable, Subject, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {AlarmParametersFormCombinationAlarmComponent} from './alarm-parameters-forms/alarm-parameters-form-combination-alarm/alarm-parameters-form-combination-alarm.component';
import {StepperSelectionEvent} from '@angular/cdk/stepper';

@Component({
    selector: 'app-project-alarm-parameters',
    templateUrl: './project-alarm-parameters.component.html',
    styleUrls: ['./project-alarm-parameters.component.css']
})
export class ProjectAlarmParametersComponent implements AfterViewInit, OnChanges, OnDestroy {

    @Input() params;
    @Input() readOnly: boolean;
    @Input() alarmName: string;
    @Input() projectId: string;
    @Input() invalidFieldsArray: any[] = [];
    @Input() changeVueObservable: Observable<any>;
    @Input() alarmId: string;
    @Output() next: EventEmitter<any> = new EventEmitter();
    @Output() back = new EventEmitter();
    @Output() updateValue = new EventEmitter();
    @Output() invalidFields = new EventEmitter();
    @ViewChild(DefaultViewContainerRefDirective) alarmParameterFormHost: DefaultViewContainerRefDirective;
    paramsChange = new Subject();
    paramsFormComponentInstance: AlarmParameterDefaultForm;   // Component dynamically instanced
    changeVueSubsc: Subscription;
    disableAlarmCreation: boolean;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private changeDetectorRef: ChangeDetectorRef,
                private toastrService: ToastrService,
                private translateService: TranslateService) {
    }

    ngAfterViewInit() {
        const alarmParameterFormComponentFactory = this.componentFactoryResolver
            .resolveComponentFactory(alarmNameTypeMapping[this.alarmName]);

        const alarmParameterFormHostRef = this.alarmParameterFormHost.viewContainerRef;
        alarmParameterFormHostRef.clear();

        this.paramsFormComponentInstance = (<AlarmParameterDefaultForm>alarmParameterFormHostRef
            .createComponent(alarmParameterFormComponentFactory).instance);
        this.paramsFormComponentInstance.paramsChange = this.paramsChange;
        this.paramsFormComponentInstance.params = this.params;
        this.paramsFormComponentInstance.alarmId = this.alarmId;
        this.paramsFormComponentInstance.projectId = this.projectId;
        this.paramsFormComponentInstance.invalidFields = this.invalidFieldsArray;
        if (this.readOnly) {
            this.paramsFormComponentInstance.readOnly = true;
        }
        this.changeDetectorRef.detectChanges();

        if (this.changeVueObservable) {
            this.changeVueSubsc = this.changeVueObservable
                .subscribe(
                (stepperChange: StepperSelectionEvent) => {
                    if (stepperChange.selectedIndex === 1) {
                        this.enterParamView();
                    }
                    if (stepperChange.previouslySelectedIndex === 1) {
                        this.exitParamView();
                    }
                }
            );
        }

        if ('combination-alarm' === this.alarmName) {
            (<AlarmParametersFormCombinationAlarmComponent>this.paramsFormComponentInstance).disableAlarmCreation.subscribe(
                () => this.disableAlarmCreation = true
            );
        }
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.alarmName && changes.alarmName.previousValue) {
            this.ngOnDestroy();
            this.ngAfterViewInit();
            return;
        }

        // seems the new component variables values are not passed by reference, so we need to update them 'manually'
        if (this.paramsFormComponentInstance) {
            this.paramsFormComponentInstance.params = this.params;
            this.paramsFormComponentInstance.projectId = this.projectId;
            this.paramsFormComponentInstance.invalidFields = this.invalidFieldsArray;
            this.paramsFormComponentInstance.paramsChange.next(changes);
        }
    }

    ngOnDestroy() {
        if (this.changeVueSubsc) {
            this.changeVueSubsc.unsubscribe();
        }
    }

    enterParamView() {
        this.paramsFormComponentInstance.viewIsInited.next(true);
    }

    exitParamView(goToNextStep = false) {
        this.paramsFormComponentInstance.submitted.next(true);
        const invalidFields = [];
        if (this.paramsFormComponentInstance.form.valid) {
            this.updateValue.emit(this.paramsFormComponentInstance.form.value);
            if (goToNextStep) {
                this.next.emit(true);
            }
        } else {
            Object.entries(this.paramsFormComponentInstance.form.controls).forEach(
                (controlKeyValue) => {
                    controlKeyValue[1].markAsTouched();
                    if (controlKeyValue[1].invalid) {
                        invalidFields.push(controlKeyValue[0]);
                    }
                }
            );
            this.toastrService.error(this.translateService.instant('ALARM_FORM_VALUE_INCORRECT_PARAMS_MESSAGE'));
        }
        this.invalidFields.emit(invalidFields);
    }

}
